import { render, staticRenderFns } from "./InstantMarketingProfile.vue?vue&type=template&id=4bbea707&"
import script from "./InstantMarketingProfile.vue?vue&type=script&lang=js&"
export * from "./InstantMarketingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports